import { render, staticRenderFns } from "./SearchOrAddClient.vue?vue&type=template&id=23f67d5c&scoped=true"
import script from "./SearchOrAddClient.vue?vue&type=script&lang=js"
export * from "./SearchOrAddClient.vue?vue&type=script&lang=js"
import style0 from "./SearchOrAddClient.vue?vue&type=style&index=0&id=23f67d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f67d5c",
  null
  
)

export default component.exports